import { createContext, type JSX, type ReactNode, useState } from "react";

interface Props {
  children?: ReactNode;
}

export interface IDataSourceContext {
  dataSourceId: number | null;
  setDataSourceId: (dataSourceId: number) => void;
}

const initial = {
  dataSourceId: null,
  setDataSourceId: (): void => {},
};

const DataSourceContext = createContext<IDataSourceContext>(initial);

const DataSourceProvider = ({ children }: Props): JSX.Element => {
  const [dataSourceId, setDataSourceId] = useState<number | null>(null);

  return (
    <DataSourceContext.Provider value={{ dataSourceId, setDataSourceId }}>
      {children}
    </DataSourceContext.Provider>
  );
};

export { DataSourceContext, DataSourceProvider };
